// extracted by mini-css-extract-plugin
export default {"root":"FloatingTooltip_root__NbfrL"};